import { isServer } from 'common/utils/utilities.ts';
import type { LocalStorageKey } from 'common/local-storage/types.ts';

export function localStorageSet<Data = string>(key: string | LocalStorageKey, value: Data, stringify = true) {
  const keyString = (key as unknown as LocalStorageKey).key || (key as unknown as string);
  if (!isServer() && localStorage) {
    if (stringify) localStorage.setItem(keyString, JSON.stringify(value));
    else {
      // @ts-expect-error value: Data is not assignable to string
      localStorage.setItem(keyString, value);
    }
  }
}

type Parse = 'PARSE' | 'RAW';
type TReturnLocalStorageGet<Data, P extends Parse> = (P extends 'PARSE' ? Data : string) | null;
export function localStorageGet<Data = unknown, P extends Parse = 'PARSE'>(
  key: string | LocalStorageKey,
  parse = true,
): TReturnLocalStorageGet<Data, P> {
  const keyString = (key as unknown as LocalStorageKey).key || (key as unknown as string);
  if (parse) {
    try {
      // @ts-expect-error // due to strong type-checking, ts is forbidding passing localstorageItem to JSON.parse but it is fine as we have wrapped the func in try-catch
      return JSON.parse(localStorage.getItem(keyString)) as unknown as Data;
    } catch (e) {
      /** handling unexpected End of Input error **/
      console.log('Error parsing the value retrieved from the localStorage', keyString);
      return null;
    }
  } else {
    // @ts-expect-error 'RAW' is not assignable to string
    return localStorage.getItem(keyString) as unknown as TReturnLocalStorageGet<Data, 'RAW'>;
  }
}

export const localStorageRemove = (key: string | LocalStorageKey) => {
  try {
    const keyString = (key as unknown as LocalStorageKey).key || (key as unknown as string);
    if (!isServer() && localStorage) localStorage.removeItem(keyString);
  } catch (e) {
    console.log('Error removing the item from the localStorage', key);
  }
};

export const localStorageClear = () => {
  if (!isServer() && localStorage) localStorage.clear();
};
